import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useContext } from 'react';
import classnames from 'classnames';
import { FormLabel as MuiFormLabel } from '@material-ui/core';
import { DensityContext, withStyles } from '@jpmuitk/theme';
import { Necessity, NecessityIndicator as DefaultNecessityIndicator, NecessityStyle, StatusIndicator } from './internal';
import { formLabelStyle } from './formLabelStyle';
var FormLabel = /*#__PURE__*/forwardRef(function FormLabel(props, ref) {
  var _classnames;

  var contextDensity = useContext(DensityContext);

  var className = props.className,
      classes = props.classes,
      children = props.children,
      _props$density = props.density,
      density = _props$density === void 0 ? contextDensity : _props$density,
      _props$float = props["float"],
      _float = _props$float === void 0 ? true : _props$float,
      hasEndAdornment = props.hasEndAdornment,
      hasStartAdornment = props.hasStartAdornment,
      _props$hasStatusIndic = props.hasStatusIndicator,
      hasStatusIndicator = _props$hasStatusIndic === void 0 ? false : _props$hasStatusIndic,
      statusIndicatorProps = props.StatusIndicatorProps,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'float' : _props$labelPlacement,
      readOnly = props.readOnly,
      _props$shrink = props.shrink,
      shrink = _props$shrink === void 0 ? true : _props$shrink,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      _props$necessityStyle = props.necessityStyle,
      necessityStyle = _props$necessityStyle === void 0 ? NecessityStyle.FULL : _props$necessityStyle,
      _props$NecessityIndic = props.NecessityIndicator,
      NecessityIndicator = _props$NecessityIndic === void 0 ? DefaultNecessityIndicator : _props$NecessityIndic,
      _props$displayedNeces = props.displayedNecessity,
      displayedNecessity = _props$displayedNeces === void 0 ? Necessity.REQUIRED : _props$displayedNeces,
      rest = _objectWithoutProperties(props, ["className", "classes", "children", "density", "float", "hasEndAdornment", "hasStartAdornment", "hasStatusIndicator", "StatusIndicatorProps", "labelPlacement", "readOnly", "shrink", "required", "necessityStyle", "NecessityIndicator", "displayedNecessity"]);

  return /*#__PURE__*/React.createElement(MuiFormLabel, _assign({
    className: classnames(className, classes.root, classes["".concat(density, "Density")], (_classnames = {}, _defineProperty(_classnames, classes["float"], _float), _defineProperty(_classnames, classes.hasEndAdornment, hasEndAdornment), _defineProperty(_classnames, classes.hasStartAdornment, hasStartAdornment), _defineProperty(_classnames, classes.readOnly, readOnly), _defineProperty(_classnames, classes.shrink, shrink), _defineProperty(_classnames, classes.labelLeft, labelPlacement === 'left'), _defineProperty(_classnames, classes.labelTop, labelPlacement === 'top'), _classnames)),
    classes: {
      disabled: classes.disabled
    },
    ref: ref
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classes.textContainer
  }, children), /*#__PURE__*/React.createElement(NecessityIndicator, {
    className: classes.necessityIndicator,
    displayedNecessity: displayedNecessity,
    necessityStyle: necessityStyle,
    required: required
  }), hasStatusIndicator && /*#__PURE__*/React.createElement(StatusIndicator, _assign({
    className: classes.statusIndicator,
    classes: {
      tooltipRoot: classes.statusIndicatorTooltipRoot,
      iconRoot: classes.statusIndicatorIconRoot,
      iconError: classes.statusIndicatorStateIconError,
      iconInfo: classes.statusIndicatorStateIconInfo,
      iconSuccess: classes.statusIndicatorStateIconSuccess,
      iconWarning: classes.statusIndicatorStateIconWarning,
      stateIconContainer: classes.statusIndicatorStateIconContainer
    },
    hasTooltip: true
  }, statusIndicatorProps)));
}); // TODO (BREAKING CHANGE REQUIRED)
// https://issuetracking.jpmchase.net/jira12/browse/JPMUITK-2835
// Add unique JPMUI prefix to name to identify component as a Toolkit component

export default withStyles(formLabelStyle, {
  name: 'FormLabel'
})(FormLabel);
//# sourceMappingURL=FormLabel.js.map